export default {
  dayOffList: [],
  dayOffDateList: [],
  currentPage: null
}
